module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.isAccessAllowed('LoopOp_SecurityUsers_ReadAll')) ? _c('div', [_c('ImportUsersModal', {
    attrs: {
      "showDialog": _vm.showImportUsersDialog,
      "roleData": _vm.roleData,
      "clientList": _vm.clientList,
      "agencyList": _vm.agencyList
    },
    on: {
      "dialogClosed": function($event) {
        _vm.showImportUsersDialog = false
      },
      "importComplete": function($event) {
        return _vm.getUserData()
      }
    }
  }), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('confirmation-dialog', {
    attrs: {
      "dialogId": 'UserManagementExportUsersConfirmation',
      "confirmationTitle": _vm.lang.S0180,
      "yesButtonText": _vm.lang.S0181,
      "noButtonText": _vm.lang.S0182,
      "showDialog": _vm.showExportDialog
    },
    on: {
      "onYesConfirmation": _vm.exportUsers,
      "dialogClosed": function($event) {
        _vm.showExportDialog = false
      }
    }
  }, [
    [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-md-2 control-label",
      attrs: {
        "for": "exportUsersUserTypeSelect"
      }
    }, [_vm._v(_vm._s(_vm.lang.S0183))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10"
    }, [_c('select2', {
      staticClass: "form-control",
      attrs: {
        "id": "exportUsersUserTypeSelect",
        "afterChange": function (u) {
          _vm.exportUsersDialogDataUserID = u;
        },
        "placeholder": _vm.lang.S0184,
        "dataTransformer": function (data) { return Number(data[0].id); },
        "allowClear": true
      },
      model: {
        value: (_vm.exportUsersDialogData.UserTypeId),
        callback: function($$v) {
          _vm.$set(_vm.exportUsersDialogData, "UserTypeId", $$v)
        },
        expression: "exportUsersDialogData.UserTypeId"
      }
    }, _vm._l((_vm.roleData.filter(
      function (r) { return r.RoleTypeName !== 'MSM_Administrator'; }
    )), function(type) {
      return _c('option', {
        key: type.RoleTypeGuid,
        domProps: {
          "value": type.UserTypeId
        }
      }, [_vm._v("\n              " + _vm._s(type.RoleTypeDisplayName) + "\n            ")])
    }), 0)], 1)]), _vm._v(" "), (_vm.exportUsersDialogDataUserID == 4) ? [_c('label', {
      staticClass: "col-md-2 control-label",
      attrs: {
        "for": "exportUsersClientSelect"
      }
    }, [_vm._v(_vm._s(_vm.lang.S0185))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10"
    }, [_c('select2', {
      key: _vm.exportUsersDialogData.UserTypeId,
      staticClass: "form-control",
      attrs: {
        "id": "exportUsersClientSelect",
        "placeholder": _vm.lang.S0186,
        "allowClear": true
      },
      model: {
        value: (_vm.exportUsersDialogData.ClientId),
        callback: function($$v) {
          _vm.$set(_vm.exportUsersDialogData, "ClientId", $$v)
        },
        expression: "exportUsersDialogData.ClientId"
      }
    }, _vm._l((_vm.clientList), function(client) {
      return _c('option', {
        key: client.ClientId,
        domProps: {
          "value": client.ClientId
        }
      }, [_vm._v("\n              " + _vm._s(client.ClientName) + "\n            ")])
    }), 0)], 1)] : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.exportUsersDialogData.UserTypeId == 2),
        expression: "exportUsersDialogData.UserTypeId == 2"
      }],
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-md-2 control-label",
      attrs: {
        "for": "exportUsersAgencySelect"
      }
    }, [_vm._v(_vm._s(_vm.lang.S0187))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10"
    }, [_c('select2', {
      staticClass: "form-control",
      attrs: {
        "id": "exportUsersAgencySelect",
        "placeholder": _vm.lang.S0188,
        "allowClear": true
      },
      model: {
        value: (_vm.exportUsersDialogData.AgencyId),
        callback: function($$v) {
          _vm.$set(_vm.exportUsersDialogData, "AgencyId", $$v)
        },
        expression: "exportUsersDialogData.AgencyId"
      }
    }, _vm._l((_vm.agencyList), function(agency) {
      return _c('option', {
        key: agency.AgencyGuid,
        domProps: {
          "value": agency.AgencyId
        }
      }, [_vm._v("\n              " + _vm._s(agency.AgencyName) + "\n            ")])
    }), 0)], 1)])]
  ], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "users-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "user-management-refresh-button",
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        return _vm.getUserData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0000) + "\n        ")]), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SecurityUsers_Create')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "user-management-create-button"
    },
    on: {
      "click": function($event) {
        (_vm.selectedUser = ''), _vm.openEditUserDialog('create')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0001) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SecurityUsers_Read')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "user-management-edit-button",
      "disabled": !_vm.selectedUser
    },
    on: {
      "click": function($event) {
        return _vm.openEditUserDialog('edit')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("edit")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0002) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SecurityUsers_Create')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedUser
    },
    on: {
      "click": function($event) {
        _vm.openEditUserDialog('edit'), (_vm.copyUser = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("content_copy")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0146) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SecurityUsers_Delete')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "user-management-delete-button",
      "disabled": !_vm.selectedUser
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteUserDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("clear")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0083) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SecurityGroups_ReadAll')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedUser
    },
    on: {
      "click": function($event) {
        return _vm.openSecurityDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("lock")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0003) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.globals.isAgencyUser) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedUserData.ClientGuid
    },
    on: {
      "click": function($event) {
        return _vm.openSecurity2Dialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("lock")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0138) + "\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed('LoopOp_Password_ChangePassword') &&
    _vm.globals.isAccessAllowed('LoopOp_Password_ValidatePassword')
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedUser
    },
    on: {
      "click": function($event) {
        return _vm.openChangePasswordDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("vpn_key")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0062) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SecurityUsersExport_Create')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        _vm.showExportDialog = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("file_download")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0134) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SecurityUsersImport_Create')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        _vm.showImportUsersDialog = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("publish")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0135) + "\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Search),
      expression: "filterStrings.Search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "id": "inputSearch",
      "placeholder": _vm.lang.S0004
    },
    domProps: {
      "value": (_vm.filterStrings.Search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Search", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.S0005))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == 1
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.S0006))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == _vm.pageCount,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount, 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.S0007))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "usersTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.totalElementsCount))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "usersTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.S0200))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "table-space main-table-scrollbar"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('RoleType')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.S0009) + "\n                  "), (_vm.sortField == 'RoleType' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'RoleType' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('Role')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.S0133) + "\n                  "), (_vm.sortField == 'Role' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'Role' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('Active')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.S0163) + "\n                  "), (_vm.sortField == 'Active' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'Active' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('Company')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.S0160) + "\n                  "), (_vm.sortField == 'Company' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'Company' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('LoginName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.S0010) + "\n                  "), (_vm.sortField == 'LoginName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LoginName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('FirstName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.S0011) + "\n                  "), (_vm.sortField == 'FirstName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'FirstName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('LastName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.S0012) + "\n                  "), (_vm.sortField == 'LastName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LastName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('Gender')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.S0013) + "\n                  "), (_vm.sortField == 'Gender' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'Gender' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('City')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.S0014) + "\n                  "), (_vm.sortField == 'City' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'City' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('Country')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.S0016) + "\n                  "), (_vm.sortField == 'Country' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'Country' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('Email')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.S0017) + "\n                  "), (_vm.sortField == 'Email' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'Email' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])]), _vm._v(" "), _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.RoleType),
      expression: "filterStrings.RoleType"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.RoleType)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "RoleType", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Role),
      expression: "filterStrings.Role"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.Role)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Role", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        (_vm.filterStrings.Active = (_vm.filterStrings.Active + 1) % 3),
        _vm.getUserData()
      }
    }
  }, [(_vm.filterStrings.Active == 1) ? _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box")])]) : (_vm.filterStrings.Active == 0) ? _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")])]) : _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("indeterminate_check_box")])])])])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Company),
      expression: "filterStrings.Company"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.Company)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Company", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LoginName),
      expression: "filterStrings.LoginName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.LoginName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LoginName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.FirstName),
      expression: "filterStrings.FirstName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.FirstName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "FirstName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LastName),
      expression: "filterStrings.LastName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.LastName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LastName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Gender),
      expression: "filterStrings.Gender"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.Gender)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Gender", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.City),
      expression: "filterStrings.City"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.City)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "City", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Country),
      expression: "filterStrings.Country"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.Country)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Country", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Email),
      expression: "filterStrings.Email"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.Email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Email", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.userData), function(user) {
    return _c('tr', {
      key: user.UserId,
      class: {
        info: user.UserId == _vm.selectedUser
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (_vm.selectedUser = user.UserId), (_vm.selectedUserData = user)
        },
        "dblclick": function($event) {
          !_vm.globals.isAccessAllowed('LoopOp_SecurityUsers_Read') ||
            _vm.openEditUserDialog('edit')
        }
      }
    }, [_c('td', [_vm._v(_vm._s(user.RoleType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.Role))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "6px 0 0 0"
      }
    }, [(user.Active) ? _c('i', {
      staticClass: "material-icons md-24 user-active"
    }, [_vm._v("done")]) : _c('i', {
      staticClass: "material-icons md-24 user-inactive"
    }, [_vm._v("clear")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.Company))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.LoginName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.FirstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.LastName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.Gender))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.City))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.Country))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.Email))])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editUser",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.editUserDialogData.dialogTitle))])]), _vm._v(" "), (_vm.editUserDialogData.userData.UserId != undefined) ? _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("ID: " + _vm._s(_vm.editUserDialogData.userData.UserId))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons md-24",
    attrs: {
      "id": "showUserHistoryInfoIcon"
    },
    on: {
      "click": function($event) {
        return _vm.showUserHistory()
      }
    }
  }, [_vm._v("history")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "showUserHistoryInfoIcon",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.S0201))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordion",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingGeneral",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseGeneral",
      "aria-expanded": "true",
      "aria-controls": "collapseGeneral"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.S0019))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseGeneral",
      "role": "tabpanel",
      "aria-labelledby": "headingGeneral"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLoginName"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0020) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.LoginName),
      expression: "editUserDialogData.userData.LoginName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLoginName",
      "name": "inputLoginName",
      "required": ""
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.LoginName)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputLoginName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "LoginName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputLoginName')),
      expression: "inputHasError('inputLoginName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0095))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputFirstName"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0022) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.FirstName),
      expression: "editUserDialogData.userData.FirstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputFirstName",
      "name": "inputFirstName",
      "required": ""
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.FirstName)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputFirstName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "FirstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputFirstName')),
      expression: "inputHasError('inputFirstName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0095))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLastName"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0023) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.LastName),
      expression: "editUserDialogData.userData.LastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLastName",
      "name": "inputLastName",
      "required": ""
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.LastName)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputLastName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "LastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputLastName')),
      expression: "inputHasError('inputLastName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0095))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCompanyName"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0024))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.CompanyName),
      expression: "editUserDialogData.userData.CompanyName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputCompanyName"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.CompanyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "CompanyName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputGender"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0025) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    key: _vm.editUserDialogData.userData.Gender,
    staticClass: "form-control",
    attrs: {
      "id": "inputUserGender",
      "placeholder": _vm.lang.S0041,
      "required": ""
    },
    on: {
      "change": function($event) {
        return _vm.validationInput('inputUserGender')
      }
    },
    model: {
      value: (_vm.editUserDialogData.userData.Gender),
      callback: function($$v) {
        _vm.$set(_vm.editUserDialogData.userData, "Gender", $$v)
      },
      expression: "editUserDialogData.userData.Gender"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.S0041) + "\n                        ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "M"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0026))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "F"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0027))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0203))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputUserGender')),
      expression: "inputHasError('inputUserGender')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0095))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputRoleType"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0009))]), _vm._v(" "), (_vm.editUserDialogData.userData.RoleTypeGuid) ? _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    key: _vm.editUserDialogData.userData.RoleTypeGuid,
    staticClass: "form-control",
    attrs: {
      "id": "editUserDialogData.userData.RoleTypeGuid",
      "afterChange": _vm.roleTypeChanged
    },
    model: {
      value: (_vm.editUserDialogData.userData.RoleTypeGuid),
      callback: function($$v) {
        _vm.$set(_vm.editUserDialogData.userData, "RoleTypeGuid", $$v)
      },
      expression: "editUserDialogData.userData.RoleTypeGuid"
    }
  }, _vm._l((_vm.roleData), function(roleType) {
    return _c('option', {
      key: roleType.RoleTypeGuid,
      domProps: {
        "value": roleType.RoleTypeGuid
      }
    }, [_vm._v("\n                          " + _vm._s(roleType.RoleTypeDisplayName) + "\n                        ")])
  }), 0)], 1) : _vm._e()]), _vm._v(" "), (
    _vm.globals.roleTypeHasSuffix(
      _vm.editUserDialogData.userData.RoleTypeGuid,
      'Agency'
    )
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "selectAgency"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0116) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "selectAgency",
      "name": "selectAgency",
      "afterChange": function (a) {
        _vm.validateInput('selectAgency');
      },
      "placeholder": _vm.lang.S0041,
      "required": ""
    },
    model: {
      value: (_vm.editUserDialogData.userData.AgencyGuid),
      callback: function($$v) {
        _vm.$set(_vm.editUserDialogData.userData, "AgencyGuid", $$v)
      },
      expression: "editUserDialogData.userData.AgencyGuid"
    }
  }, _vm._l((_vm.agencyList), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyGuid
      }
    }, [_vm._v("\n                          " + _vm._s(agency.AgencyName) + "\n                        ")])
  }), 0)], 1)]) : _vm._e(), _vm._v(" "), (
    _vm.globals.roleTypeHasSuffix(
      _vm.editUserDialogData.userData.RoleTypeGuid,
      'Client'
    )
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "selectClient"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0111) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.editUserDialogData.userData.RoleTypeGuid) ? _c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "selectClient",
      "name": "selectClient",
      "dataTransformer": function (data) { return Number(data[0].id); },
      "afterChange": function (c) {
        _vm.validateInput('selectClient');
      },
      "placeholder": _vm.lang.S0041,
      "required": ""
    },
    model: {
      value: (_vm.editUserDialogData.userData.ClientId),
      callback: function($$v) {
        _vm.$set(_vm.editUserDialogData.userData, "ClientId", $$v)
      },
      expression: "editUserDialogData.userData.ClientId"
    }
  }, _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientId,
      domProps: {
        "value": client.ClientId
      }
    }, [_vm._v("\n                          " + _vm._s(client.ClientName) + "\n                        ")])
  }), 0) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (
    !_vm.globals.roleTypeHasSuffix(
      _vm.editUserDialogData.userData.RoleTypeGuid,
      'Audi'
    )
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "editUserSelectRole"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0133) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    key: _vm.editUserDialogData.userData.RoleGuid,
    ref: "editUserSelectRole",
    staticClass: "form-control",
    attrs: {
      "id": "editUserSelectRole",
      "name": "editUserSelectRole",
      "afterChange": function (a) {
        _vm.validateInput('editUserSelectRole');
      },
      "placeholder": _vm.lang.S0041,
      "required": ""
    },
    model: {
      value: (_vm.editUserDialogData.userData.RoleGuid),
      callback: function($$v) {
        _vm.$set(_vm.editUserDialogData.userData, "RoleGuid", $$v)
      },
      expression: "editUserDialogData.userData.RoleGuid"
    }
  }, _vm._l((_vm.editUserDialogData.currentRoles), function(role) {
    return _c('option', {
      key: role.RoleGuid,
      domProps: {
        "value": role.RoleGuid
      }
    }, [_vm._v("\n                          " + _vm._s(role.RoleDisplayName) + "\n                        ")])
  }), 0)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocalization"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0028))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    key: _vm.editUserDialogData.userData.LanguageCode,
    staticClass: "form-control",
    attrs: {
      "id": "inputLocalization",
      "placeholder": _vm.lang.S0041
    },
    model: {
      value: (_vm.editUserDialogData.userData.LanguageCode),
      callback: function($$v) {
        _vm.$set(_vm.editUserDialogData.userData, "LanguageCode", $$v)
      },
      expression: "editUserDialogData.userData.LanguageCode"
    }
  }, _vm._l((_vm.languageList), function(language, id) {
    return _c('option', {
      key: id + '_' + language,
      domProps: {
        "value": id
      }
    }, [_vm._v("\n                          " + _vm._s(language) + "\n                        ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputDefaultWelcomePage"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0030))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editUserDialogData.userData.DefaultWelcomePage
      ),
      expression: "\n                          editUserDialogData.userData.DefaultWelcomePage\n                        "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputDefaultWelcomePage"
    },
    domProps: {
      "value": (
        _vm.editUserDialogData.userData.DefaultWelcomePage
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "DefaultWelcomePage", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputDefaultWelcomePage",
      "delay": _vm.globals.tooltipDelay,
      "placement": "right"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.S0031) + ":")]), _vm._v(" "), _c('br'), _vm._v("clientname.msmloop.com\n                      ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputDisabled"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0033))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.Active),
      expression: "editUserDialogData.userData.Active"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUserDialogData.userData, "Active", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.$forceUpdate()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0034))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0035))])])])]), _vm._v(" "), (
    _vm.selectedUserData.RoleGuid === 'Market' &&
    _vm.selectedUserData.RoleTypeGuid === 'Client'
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputMarket"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0202))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.Market_short),
      expression: "editUserDialogData.userData.Market_short"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUserDialogData.userData, "Market_short", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.$forceUpdate()
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.S0041) + "\n                        ")]), _vm._v(" "), _vm._l((_vm.marketList), function(market, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": market.marketShortName
      }
    }, [_vm._v("\n                          " + _vm._s(market.marketShortName) + "\n                        ")])
  })], 2)])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingContact",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseContact",
      "aria-expanded": "false",
      "aria-controls": "collapseContact"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.S0036))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseContact",
      "role": "tabpanel",
      "aria-labelledby": "headingContact"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAddress1"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0037))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.Address1),
      expression: "editUserDialogData.userData.Address1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAddress1"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.Address1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "Address1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAddress2"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0038))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.Address2),
      expression: "editUserDialogData.userData.Address2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAddress2"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.Address2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "Address2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCity"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0039))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.City),
      expression: "editUserDialogData.userData.City"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputCity"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.City)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "City", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCountry"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0042))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.Country),
      expression: "editUserDialogData.userData.Country"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUserDialogData.userData, "Country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changedCountry(_vm.editUserDialogData.userData.Country)
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.S0041) + "\n                        ")]), _vm._v(" "), _vm._l((_vm.globals.countryList), function(country, ISOCode) {
    return _c('option', {
      key: ISOCode,
      domProps: {
        "value": ISOCode
      }
    }, [_vm._v("\n                          " + _vm._s(country) + "\n                        ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputRegion"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0040))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.RegionGuid),
      expression: "editUserDialogData.userData.RegionGuid"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.editUserDialogData.currentRegions.length < 1
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUserDialogData.userData, "RegionGuid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(_vm.editUserDialogData.currentRegions.length > 0) ? _c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.S0041) + "\n                        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.editUserDialogData.currentRegions), function(region) {
    return _c('option', {
      key: region.RegionGuid,
      domProps: {
        "value": region.RegionGuid
      }
    }, [_vm._v("\n                          " + _vm._s(region.RegionName) + "\n                        ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputTimeZone"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0029))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.TimeZone),
      expression: "editUserDialogData.userData.TimeZone"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.editUserDialogData.currentTimeZones.length < 1
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUserDialogData.userData, "TimeZone", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(
    _vm.editUserDialogData.currentTimeZones.length > 0
  ) ? _c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.S0041) + "\n                        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.editUserDialogData.currentTimeZones), function(tz) {
    return _c('option', {
      key: tz.TimeZoneId,
      domProps: {
        "value": tz.TimeZoneId
      }
    }, [_vm._v("\n                          " + _vm._s(tz.TimeZoneName) + "\n                        ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputPostalCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0043))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.PostalCode),
      expression: "editUserDialogData.userData.PostalCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputPostalCode"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.PostalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "PostalCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-small"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputGeographyFromGeocoding_Lat"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0117))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editUserDialogData.userData
        .GeographyFromGeocoding_Lat
      ),
      expression: "\n                          editUserDialogData.userData\n                            .GeographyFromGeocoding_Lat\n                        "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.000001",
      "min": "-90",
      "max": "90",
      "id": "inputGeographyFromGeocoding_Lat"
    },
    domProps: {
      "value": (
        _vm.editUserDialogData.userData
        .GeographyFromGeocoding_Lat
      )
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "GeographyFromGeocoding_Lat", $event.target.value)
      }, function($event) {
        return _vm.validateInput('inputGeographyFromGeocoding_Lat')
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.inputHasError('inputGeographyFromGeocoding_Lat')
      ),
      expression: "\n                          inputHasError('inputGeographyFromGeocoding_Lat')\n                        "
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0122))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-small"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "GeographyFromGeocoding_Long"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0118))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editUserDialogData.userData
        .GeographyFromGeocoding_Long
      ),
      expression: "\n                          editUserDialogData.userData\n                            .GeographyFromGeocoding_Long\n                        "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.000001",
      "min": "-180",
      "max": "180",
      "id": "GeographyFromGeocoding_Long"
    },
    domProps: {
      "value": (
        _vm.editUserDialogData.userData
        .GeographyFromGeocoding_Long
      )
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "GeographyFromGeocoding_Long", $event.target.value)
      }, function($event) {
        return _vm.validateInput('GeographyFromGeocoding_Long')
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('GeographyFromGeocoding_Long')),
      expression: "inputHasError('GeographyFromGeocoding_Long')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0122))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-small"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "GeographyFromPostalCode_Lat"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0119))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editUserDialogData.userData
        .GeographyFromPostalCode_Lat
      ),
      expression: "\n                          editUserDialogData.userData\n                            .GeographyFromPostalCode_Lat\n                        "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.000001",
      "min": "-90",
      "max": "90",
      "id": "GeographyFromPostalCode_Lat"
    },
    domProps: {
      "value": (
        _vm.editUserDialogData.userData
        .GeographyFromPostalCode_Lat
      )
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "GeographyFromPostalCode_Lat", $event.target.value)
      }, function($event) {
        return _vm.validateInput('GeographyFromPostalCode_Lat')
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('GeographyFromPostalCode_Lat')),
      expression: "inputHasError('GeographyFromPostalCode_Lat')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0122))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-small"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "GeographyFromPostalCode_Long"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0120))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editUserDialogData.userData
        .GeographyFromPostalCode_Long
      ),
      expression: "\n                          editUserDialogData.userData\n                            .GeographyFromPostalCode_Long\n                        "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.000001",
      "min": "-180",
      "max": "180",
      "id": "GeographyFromPostalCode_Long"
    },
    domProps: {
      "value": (
        _vm.editUserDialogData.userData
        .GeographyFromPostalCode_Long
      )
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "GeographyFromPostalCode_Long", $event.target.value)
      }, function($event) {
        return _vm.validateInput('GeographyFromPostalCode_Long')
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('GeographyFromPostalCode_Long')),
      expression: "inputHasError('GeographyFromPostalCode_Long')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0122))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputDistanceUnit"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0121))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.DistanceUnit),
      expression: "editUserDialogData.userData.DistanceUnit"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUserDialogData.userData, "DistanceUnit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.S0041) + "\n                        ")]), _vm._v(" "), _vm._l((_vm.distanceUnits), function(unit, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                          " + _vm._s(unit) + "\n                        ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputPhoneHome"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0044))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.PhoneHome),
      expression: "editUserDialogData.userData.PhoneHome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputPhoneHome"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.PhoneHome)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputPhoneHome')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "PhoneHome", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputPhoneHome')),
      expression: "inputHasError('inputPhoneHome')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0096))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputPhoneWork"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0045))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.PhoneWork),
      expression: "editUserDialogData.userData.PhoneWork"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputPhoneWork"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.PhoneWork)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputPhoneWork')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "PhoneWork", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputPhoneWork')),
      expression: "inputHasError('inputPhoneWork')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0096))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputPhoneMobile"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0046))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.PhoneMobile),
      expression: "editUserDialogData.userData.PhoneMobile"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputPhoneMobile"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.PhoneMobile)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputPhoneMobile')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "PhoneMobile", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputPhoneMobile')),
      expression: "inputHasError('inputPhoneMobile')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0096))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputFax"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0047))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.Fax),
      expression: "editUserDialogData.userData.Fax"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputFax"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.Fax)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputFax')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "Fax", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputFax')),
      expression: "inputHasError('inputFax')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0097))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0048))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.Email),
      expression: "editUserDialogData.userData.Email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "inputEmail",
      "name": "inputEmail"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.Email)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputEmail')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "Email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputEmail')),
      expression: "inputHasError('inputEmail')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0098))])])])])])])]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.editUserDialogData.showAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.editUserDialogData.showAlert = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.S0049))])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.copyUser = false
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.S0050) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "id": "user-management-modal-save-button",
      "type": "button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_SecurityUsers_Update')
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('editUser')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.S0051) + "\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "securityDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg",
    staticStyle: {
      "width": "80vw"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.S0054))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getSelectedUserInfoText()))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-security",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [(
    _vm.globals.isAccessAllowed(
      'LoopOp_SecurityGroups_ReadAll'
    ) &&
    _vm.globals.isAccessAllowed(
      'LoopOp_SecurityUsersSecurityGroups_Read'
    )
  ) ? _c('a', {
    attrs: {
      "href": "#customGroupDataTab",
      "data-toggle": "tab"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0056))]) : _vm._e()]), _vm._v(" "), _c('li', [(
    _vm.globals.isAccessAllowed('LoopOp_SecurityGroups_ReadAll')
  ) ? _c('a', {
    attrs: {
      "href": "#groupManagementTab",
      "data-toggle": "tab"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0064))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_vm._l((_vm.securityDialogData.dataLists), function(groupList, key) {
    return _c('div', {
      key: key,
      staticClass: "tab-pane fade in",
      class: {
        active: key == 'customGroupData'
      },
      attrs: {
        "id": key + 'Tab'
      }
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('button', {
      staticClass: "btn btn-fab btn-fab-mini dialog-btn-primary",
      attrs: {
        "disabled": _vm.securityDialogData.selectedAssignedGroupGuids
          .length == 0 ||
          !_vm.globals.isAccessAllowed(
            'LoopOp_SecurityUsersSecurityGroups_Update'
          )
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.unassignGroups()
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("arrow_back")])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-fab btn-fab-mini dialog-btn-primary",
      attrs: {
        "disabled": _vm.securityDialogData.selectedUnassignedGroupGuids
          .length == 0 ||
          !_vm.globals.isAccessAllowed(
            'LoopOp_SecurityUsersSecurityGroups_Update'
          )
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.assignGroups()
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("arrow_forward")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('table', {
      staticClass: "table table-striped table-hover"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "text-center sticky-header"
    }, [_vm._v("\n                            " + _vm._s(_vm.lang.S0058) + "\n                          ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.groupListAvailable), function(group) {
      return _c('tr', {
        key: group.GroupGuid,
        class: {
          info: _vm.securityDialogData.selectedUnassignedGroupGuids.indexOf(
            group.GroupGuid
          ) > -1,
        },
        attrs: {
          "role": "button"
        },
        on: {
          "click": function($event) {
            return _vm.toggleListItem(
              _vm.securityDialogData.selectedUnassignedGroupGuids,
              group.GroupGuid
            )
          },
          "dblclick": function($event) {
            !_vm.globals.isAccessAllowed(
                'LoopOp_SecurityUsersSecurityGroups_Update'
              ) ||
              ((_vm.securityDialogData.selectedUnassignedGroupGuids = []),
                _vm.toggleListItem(
                  _vm.securityDialogData.assignedGroupGuids,
                  group.GroupGuid
                ))
          }
        }
      }, [_c('td', {
        attrs: {
          "id": 'tdAvailable' + key + group.GroupName
        }
      }, [_vm._v("\n                            " + _vm._s(group.GroupName) + "\n                            "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (group.IsReportingGroup),
          expression: "group.IsReportingGroup"
        }],
        staticClass: "reporting-group-table-symbol"
      }, [_vm._v("R")])]), _vm._v(" "), _c('b-tooltip', {
        ref: "tooltip",
        refInFor: true,
        attrs: {
          "target": 'tdAvailable' + key + group.GroupName,
          "delay": _vm.globals.tooltipDelay
        }
      }, [_vm._v(_vm._s(group.GroupDescription))])], 1)
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('table', {
      staticClass: "table table-striped table-hover"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "text-center sticky-header"
    }, [_vm._v("\n                            " + _vm._s(_vm.lang.S0059) + "\n                          ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.groupListAssigned), function(group) {
      return _c('tr', {
        key: group.GroupGuid,
        class: {
          info: _vm.securityDialogData.selectedAssignedGroupGuids.indexOf(
            group.GroupGuid
          ) > -1,
        },
        attrs: {
          "role": "button"
        },
        on: {
          "click": function($event) {
            return _vm.toggleListItem(
              _vm.securityDialogData.selectedAssignedGroupGuids,
              group.GroupGuid
            )
          },
          "dblclick": function($event) {
            !_vm.globals.isAccessAllowed(
                'LoopOp_SecurityUsersSecurityGroups_Update'
              ) ||
              ((_vm.securityDialogData.selectedAssignedGroupGuids = []),
                _vm.toggleListItem(
                  _vm.securityDialogData.assignedGroupGuids,
                  group.GroupGuid
                ))
          }
        }
      }, [_c('td', {
        attrs: {
          "id": 'tdAssigned' + key + group.GroupName
        }
      }, [_vm._v("\n                            " + _vm._s(group.GroupName) + "\n                            "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (group.IsReportingGroup),
          expression: "group.IsReportingGroup"
        }],
        staticClass: "reporting-group-table-symbol"
      }, [_vm._v("R")])]), _vm._v(" "), _c('b-tooltip', {
        ref: "tooltip",
        refInFor: true,
        attrs: {
          "target": 'tdAssigned' + key + group.GroupName,
          "delay": _vm.globals.tooltipDelay
        }
      }, [_vm._v(_vm._s(group.GroupDescription))])], 1)
    }), 0)])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": "groupManagementTab"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center sticky-header"
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.S0078) + "\n                          ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.securityDialogData.dataLists
    .customGroupData), function(group) {
    return _c('tr', {
      key: group.GroupGuid,
      class: {
        info: _vm.securityDialogData.groupManagement
          .selectedGroup == group.GroupGuid,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectGroup(group.GroupGuid)
        }
      }
    }, [_c('td', {
      attrs: {
        "id": 'tdAvailableCustomGroupData' + group.GroupName
      }
    }, [_vm._v("\n                            " + _vm._s(group.GroupName) + "\n                            "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (group.IsReportingGroup),
        expression: "group.IsReportingGroup"
      }],
      staticClass: "reporting-group-table-symbol"
    }, [_vm._v("R")])]), _vm._v(" "), _c('b-tooltip', {
      ref: "tooltip",
      refInFor: true,
      attrs: {
        "target": 'tdAvailableCustomGroupData' + group.GroupName,
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(group.GroupDescription))])], 1)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center sticky-header"
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.S0079) + "\n                          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputGroupName"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0080) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.securityDialogData.groupManagement
        .selectedGroupData.GroupName
      ),
      expression: "\n                            securityDialogData.groupManagement\n                              .selectedGroupData.GroupName\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputGroupName"
    },
    domProps: {
      "value": (
        _vm.securityDialogData.groupManagement
        .selectedGroupData.GroupName
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.securityDialogData.groupManagement
          .selectedGroupData, "GroupName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputGroupDescription"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0081))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.securityDialogData.groupManagement
        .selectedGroupData.GroupDescription
      ),
      expression: "\n                            securityDialogData.groupManagement\n                              .selectedGroupData.GroupDescription\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "3",
      "id": "inputGroupDescription"
    },
    domProps: {
      "value": (
        _vm.securityDialogData.groupManagement
        .selectedGroupData.GroupDescription
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.securityDialogData.groupManagement
          .selectedGroupData, "GroupDescription", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.selectedUserData.ClientGuid) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "securityGroupsIsReportingGroupCheckbox",
      "id": "securityGroupsIsReportingGroupCheckboxLabel"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.S0191) + "\n                        "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.securityDialogData.groupManagement
        .selectedGroupData.IsReportingGroup
      ),
      expression: "\n                                securityDialogData.groupManagement\n                                  .selectedGroupData.IsReportingGroup\n                              "
    }],
    attrs: {
      "type": "checkbox",
      "id": "securityGroupsIsReportingGroupCheckbox",
      "disabled": !_vm.findNextFreeTargetGroup()
    },
    domProps: {
      "checked": Array.isArray(
        _vm.securityDialogData.groupManagement
        .selectedGroupData.IsReportingGroup
      ) ? _vm._i(
        _vm.securityDialogData.groupManagement
        .selectedGroupData.IsReportingGroup, null) > -1 : (
        _vm.securityDialogData.groupManagement
        .selectedGroupData.IsReportingGroup
      )
    },
    on: {
      "change": [function($event) {
        var $$a =
          _vm.securityDialogData.groupManagement
          .selectedGroupData.IsReportingGroup,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.securityDialogData.groupManagement
              .selectedGroupData, "IsReportingGroup", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.securityDialogData.groupManagement
              .selectedGroupData, "IsReportingGroup", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.securityDialogData.groupManagement
            .selectedGroupData, "IsReportingGroup", $$c)
        }
      }, function($event) {
        return _vm.reportingGroupFlagToggled()
      }]
    }
  }), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "securityGroupsIsReportingGroupCheckboxLabel",
      "placement": "left",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.S0195) + "\n                        "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.S0196) + "\n                      ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "securityGroupsClientSelect"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.S0185) + "\n                        "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.securityDialogData.groupManagement
        .selectedGroupData.IsReportingGroup
      ),
      expression: "\n                            securityDialogData.groupManagement\n                              .selectedGroupData.IsReportingGroup\n                          "
    }]
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "securityGroupsClientSelect",
      "allowClear": true,
      "placeholder": _vm.lang.S0186,
      "disabled": _vm.securityDialogData.groupManagement
        .selectedGroupData.IsReportingGroup
    },
    model: {
      value: (
        _vm.securityDialogData.groupManagement
        .selectedGroupData.ClientGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.securityDialogData.groupManagement
          .selectedGroupData, "ClientGuid", $$v)
      },
      expression: "\n                            securityDialogData.groupManagement\n                              .selectedGroupData.ClientGuid\n                          "
    }
  }, _vm._l((_vm.clientListWithGuid), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                            " + _vm._s(client.ClientName) + "\n                          ")])
  }), 0)], 1)]), _vm._v(" "), (
    _vm.securityDialogData.groupManagement.selectedGroupData
    .IsReportingGroup
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "targetGroupRadios"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0197))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 text-left"
  }, _vm._l((_vm.targetGroups), function(tg, guid) {
    return _c('div', {
      key: guid,
      staticClass: "radio"
    }, [_c('label', [_c('input', {
      attrs: {
        "type": "radio",
        "name": "targetGroupRadios",
        "id": ("targetGroupRadio" + tg)
      },
      domProps: {
        "value": guid,
        "checked": guid ===
          _vm.securityDialogData.groupManagement
          .selectedGroupData.TargetGroupGuid
      },
      on: {
        "change": function($event) {
          return _vm.targetGroupGuidChanged(guid)
        }
      }
    }), _vm._v("\n                            " + _vm._s(_vm.lang.S0197) + " " + _vm._s(tg) + "\n                            "), _c('span', {
      staticClass: "circle"
    }), _vm._v(" "), _c('span', {
      staticClass: "check"
    })])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearGroupManagementInputs()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.S0159) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    class: {
      'btn-warning': _vm.securityDialogData.groupManagement
        .isSelectedGroupDirty,
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.securityDialogData.groupManagement.selectedGroupData
        .GroupName ||
        (!_vm.globals.isAccessAllowed(
            'LoopOp_SecurityGroups_Create'
          ) &&
          !_vm.securityDialogData.groupManagement
          .selectedGroup) ||
        (!_vm.globals.isAccessAllowed(
            'LoopOp_SecurityGroups_Update'
          ) &&
          _vm.securityDialogData.groupManagement.selectedGroup)
    },
    on: {
      "click": function($event) {
        return _vm.editGroup()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("save")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.S0082) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.securityDialogData.groupManagement.selectedGroup ||
        !_vm.globals.isAccessAllowed(
          'LoopOp_SecurityGroups_Delete'
        )
    },
    on: {
      "click": function($event) {
        return _vm.openGroupDeletionDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("clear")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.S0083) + "\n                    ")])])])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.S0060) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveSecurityData()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.S0061) + "\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "security2Dialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.S0161))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getSelectedUserInfoText()))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(
    _vm.selectedSecurity2Page === 'locations2Tab' &&
    _vm.security2DialogData.dataLists.locations.length > 100
  ) ? _c('a', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin": "7px 0 0 0",
      "padding": "2px 20px",
      "position": "absolute"
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        (_vm.security2DialogData.showTop100LocationsOnly = !_vm.security2DialogData.showTop100LocationsOnly),
        _vm.filterLocationData()
      }
    }
  }, [(_vm.security2DialogData.showTop100LocationsOnly) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box_outline_blank")]), _vm._v("\n              " + _vm._s(_vm.lang.S0173) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.security2DialogData.hasAccessToAllLocations = !_vm.security2DialogData.hasAccessToAllLocations
      }
    }
  }, [(_vm.security2DialogData.hasAccessToAllLocations) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box_outline_blank")]), _vm._v("\n              " + _vm._s(_vm.lang.S0189) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-security",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#clientSettings2Tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedSecurity2Page = 'clientSettings2Tab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.S0139))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#locationProperties2Tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedSecurity2Page = 'locationProperties2Tab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.S0140))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#locations2Tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedSecurity2Page = 'locations2Tab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.S0141))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#reportingFeatures2Tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedSecurity2Page = 'reportingFeatures2Tab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.S0142))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": "clientSettings2Tab"
    }
  }, [_c('div', [_c('table', {
    staticClass: "table outer-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-md-8"
  }, [_vm._v(_vm._s(_vm.lang.S0174))]), _vm._v(" "), _c('th', {
    staticClass: "col-md-4"
  }, [_vm._v(_vm._s(_vm.lang.S0175))])])]), _vm._v(" "), _c('tbody', {
    staticClass: "table-scrollbar"
  }, [_vm._l((_vm.security2DialogData.dataLists
    .clientSetting), function(project) {
    return [_c('tr', {
      key: project.ProjectGuid,
      staticClass: "accordion-toggle background-grey",
      class: {
        'cursor-pointer': !project.Forbidden
      },
      attrs: {
        "data-toggle": "collapse",
        "data-target": '#securityProjectWaves' + project.ProjectGuid
      },
      on: {
        "click": function($event) {
          (project.expanded = !project.expanded),
          _vm.$forceUpdate()
        }
      }
    }, [_c('td', {
      staticClass: "project-name-data"
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (project.Forbidden),
        expression: "project.Forbidden"
      }],
      staticClass: "material-icons"
    }, [_vm._v("chevron_right")]), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!project.Forbidden && !project.expanded),
        expression: "!project.Forbidden && !project.expanded"
      }],
      staticClass: "material-icons"
    }, [_vm._v("expand_more")]), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!project.Forbidden && project.expanded),
        expression: "!project.Forbidden && project.expanded"
      }],
      staticClass: "material-icons"
    }, [_vm._v("expand_less")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(project.ProjectName))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "checkbox",
      staticStyle: {
        "margin": "0px"
      }
    }, [_c('label', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          project.expanded = false
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (project.Forbidden),
        expression: "project.Forbidden"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'cb_projectForbidden_' + project.ProjectGuid
      },
      domProps: {
        "checked": Array.isArray(project.Forbidden) ? _vm._i(project.Forbidden, null) > -1 : (project.Forbidden)
      },
      on: {
        "change": function($event) {
          var $$a = project.Forbidden,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(project, "Forbidden", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(project, "Forbidden", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(project, "Forbidden", $$c)
          }
        }
      }
    }), _vm._v(" "), _vm._m(4, true)]), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.hasForbiddenWaves(project)),
        expression: "hasForbiddenWaves(project)"
      }],
      staticClass: "material-icons"
    }, [_vm._v("priority_high")])])])]), _vm._v(" "), (!project.Forbidden) ? _c('tr', {
      key: project.ProjectGuid + 'waves'
    }, [_c('td', {
      staticClass: "hiddenRow",
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "accordion-body collapse",
      attrs: {
        "id": 'securityProjectWaves' + project.ProjectGuid
      }
    }, [(
      !project.Waves || project.Waves.length < 1
    ) ? _c('span', {
      staticStyle: {
        "margin-left": "30px"
      }
    }, [_vm._v(_vm._s(_vm.lang.S0176))]) : _c('table', {
      staticClass: "table table-hover inner-table"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(_vm.lang.S0177))]), _vm._v(" "), _c('th', {
      staticClass: "col-md-4"
    }, [_vm._v(_vm._s(_vm.lang.S0175))])])]), _vm._v(" "), _c('tbody', _vm._l((project.Waves), function(wave) {
      return _c('tr', {
        key: wave.WaveGuid
      }, [_c('td', [_vm._v(_vm._s(wave.WaveName))]), _vm._v(" "), _c('td', [_c('div', {
        staticClass: "checkbox",
        staticStyle: {
          "margin": "0px"
        }
      }, [_c('label', {
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (wave.Forbidden),
          expression: "wave.Forbidden"
        }],
        attrs: {
          "type": "checkbox",
          "id": 'cb_waveForbidden_' +
            wave.WaveGuid
        },
        domProps: {
          "checked": Array.isArray(wave.Forbidden) ? _vm._i(wave.Forbidden, null) > -1 : (wave.Forbidden)
        },
        on: {
          "change": function($event) {
            var $$a = wave.Forbidden,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(wave, "Forbidden", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(wave, "Forbidden", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(wave, "Forbidden", $$c)
            }
          }
        }
      }), _vm._v(" "), _vm._m(5, true)])])])])
    }), 0)])])])]) : _vm._e()]
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": "locationProperties2Tab"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.security2DialogData.hasAccessToAllLocations),
      expression: "security2DialogData.hasAccessToAllLocations"
    }]
  }, [_vm._v("\n                " + _vm._s(_vm.lang.S0190) + "\n              ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        !_vm.security2DialogData.hasAccessToAllLocations &&
        _vm.selectedUserData.ClientGuid
      ),
      expression: "\n                  !security2DialogData.hasAccessToAllLocations &&\n                  selectedUserData.ClientGuid\n                "
    }]
  }, [_c('CustomPropertiesPoliciesControl', {
    key: _vm.selectedUserData.ClientGuid,
    ref: "locationProperties2Tab",
    attrs: {
      "lang": _vm.lang,
      "user": _vm.selectedUserData,
      "selectedClient": _vm.selectedUserData.ClientGuid
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": "locations2Tab"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.security2DialogData.hasAccessToAllLocations),
      expression: "security2DialogData.hasAccessToAllLocations"
    }]
  }, [_vm._v("\n                " + _vm._s(_vm.lang.S0190) + "\n              ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.security2DialogData.hasAccessToAllLocations),
      expression: "!security2DialogData.hasAccessToAllLocations"
    }]
  }, [_c('div', {
    staticClass: "table-space main-table-scrollbar"
  }, [_c('table', [_c('tr', [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center sticky-header"
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.S0166) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.S0169) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.S0168) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.S0179) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.S0167) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.S0172) + "\n                            ")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.security2DialogData.locationFilterStrings
        .LocationStoreId
      ),
      expression: "\n                                    security2DialogData.locationFilterStrings\n                                      .LocationStoreId\n                                  "
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (
        _vm.security2DialogData.locationFilterStrings
        .LocationStoreId
      )
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.security2DialogData.locationFilterStrings, "LocationStoreId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.security2DialogData.locationFilterStrings
        .LocationName
      ),
      expression: "\n                                    security2DialogData.locationFilterStrings\n                                      .LocationName\n                                  "
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (
        _vm.security2DialogData.locationFilterStrings
        .LocationName
      )
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.security2DialogData.locationFilterStrings, "LocationName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.security2DialogData.locationFilterStrings
        .LocationAddress
      ),
      expression: "\n                                    security2DialogData.locationFilterStrings\n                                      .LocationAddress\n                                  "
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (
        _vm.security2DialogData.locationFilterStrings
        .LocationAddress
      )
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.security2DialogData.locationFilterStrings, "LocationAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.security2DialogData.locationFilterStrings
        .LocationCountry
      ),
      expression: "\n                                    security2DialogData.locationFilterStrings\n                                      .LocationCountry\n                                  "
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (
        _vm.security2DialogData.locationFilterStrings
        .LocationCountry
      )
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.security2DialogData.locationFilterStrings, "LocationCountry", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.security2DialogData.locationFilterStrings
        .LocationStatusId
      ),
      expression: "\n                                    security2DialogData.locationFilterStrings\n                                      .LocationStatusId\n                                  "
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (
        _vm.security2DialogData.locationFilterStrings
        .LocationStatusId
      )
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.security2DialogData.locationFilterStrings, "LocationStatusId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        (_vm.security2DialogData.locationFilterStrings.LocationVisible =
          (_vm.security2DialogData
            .locationFilterStrings
            .LocationVisible +
            1) %
          3),
        _vm.filterLocationData()
      }
    }
  }, [(
    _vm.security2DialogData
    .locationFilterStrings
    .LocationVisible == 1
  ) ? _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box")])]) : (
    _vm.security2DialogData
    .locationFilterStrings
    .LocationVisible == 0
  ) ? _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")])]) : _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("indeterminate_check_box")])])])])])]), _vm._v(" "), _vm._l((_vm.security2DialogData.dataLists
    .filteredLocations), function(location) {
    return _c('tr', {
      key: location.LocationId
    }, [_c('td', [_vm._v("\n                              " + _vm._s(location.LocationStoreId) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(location.LocationName) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(location.LocationAddress) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(location.LocationCountry) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(location.LocationStatusId) + "\n                            ")]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "btn-default btn-cb-policies",
      on: {
        "click": function($event) {
          return _vm.toggleLocationPermission(
            location.LocationGuid
          )
        }
      }
    }, [(
      _vm.isLocationPermitted(location.LocationGuid)
    ) ? _c('i', {
      staticClass: "material-icons md-24 text-primary"
    }, [_vm._v("check_box")]) : _c('i', {
      staticClass: "material-icons md-24 text-primary"
    }, [_vm._v("check_box_outline_blank")])])])])
  })], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": "reportingFeatures2Tab"
    }
  }, [_c('div', [_c('SettingsPoliciesControl', {
    ref: "reportingFeatures2Tab",
    attrs: {
      "lang": _vm.lang,
      "user": _vm.selectedUserData
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.S0164) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveSecurity2Data()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.S0061) + "\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "deleteUserDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.S0099))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.S0100))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.S0020))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.deleteUserDialogData.LoginName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.S0022))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.deleteUserDialogData.FirstName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.S0023))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.deleteUserDialogData.LastName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.S0009))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.deleteUserDialogData.RoleType))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.S0133))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.deleteUserDialogData.Role))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "id": "user-management-modal-delete-false-button",
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.S0102) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-warning",
    attrs: {
      "id": "user-management-modal-delete-true-button",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteUserData()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.S0101) + "\n          ")])])])])]), _vm._v(" "), _c('change-password-dialog', {
    attrs: {
      "showDialog": _vm.showChangePasswordDialog,
      "userGuid": _vm.selectedUser,
      "userName": _vm.selectedUserData.LoginName
    },
    on: {
      "dialogClosed": _vm.onChangePasswordDialogClosed
    }
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b33b7a0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserManagement.vue
// module id = 600
// module chunks = 1 2